export const APP_STORE_URL = 'https://apps.apple.com/tz/app/superfeo-express/id6763336828';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.smartoddssite.com';
export const APK_DOWNLOAD_URL = '/downloads/superfeo-express.apk';
export const APP_DOWNLOAD_DISMISS_KEY = 'superfeo-app-download-dismissed';
export const APP_DOWNLOAD_DISMISS_DAYS = 7;
